const FeedbackManager = ({ potenchFields }) => {
  return <div>hi</div>;
};

export default FeedbackManager;
